import { SetOptions } from '@schoolbelle/common/object-change-tracker';

export function setPriority(
  OorQ: any,
  siblingList: Array<any>,
  v_n: number,
  options: SetOptions = undefined
) {
  let v_o: number = OorQ.priority;
  if (v_o === v_n) return;

  // 1. correct value
  if (v_n !== Math.floor(v_n)) v_n = Math.floor(v_n); // must be integer.
  if (v_n > siblingList.length - 1) v_n = siblingList.length - 1; // can't skip over unused numbers
  if (v_n < 0) v_n = 0; // cannot be negativ_ne.
  if (typeof v_o === 'undefined') v_o = 1000;
  if (v_o === v_n) return;

  // 2. move others that will be affected in terms of order
  siblingList.forEach(siblingOption => {
    if (v_o < v_n) {
      if (v_o < siblingOption.priority && siblingOption.priority <= v_n) {
        siblingOption.set(['priority'], siblingOption.priority - 1, options);
      }
    } else {
      if (v_n <= siblingOption.priority && siblingOption.priority < v_o)
        siblingOption.set(['priority'], siblingOption.priority + 1, options);
    }
  });
  OorQ.set(['priority'], v_n, options);
}
